<template>
  <button
    role="checkbox"
    :aria-checked="active"
    class="bg-ontick-carbon-400 border-none"
    :class="[activeColor, { checked: active }, { 'cursor-not-allowed': disabled }]"
    @click.stop="changeValue"
    :disabled="disabled"
  />
</template>

<script>
export default {
  name: "ontick-switch",

  props: {
    active: {
      type: Boolean,
      required: true,
    },
    activeColor: {
      type: String,
      default: " text-ontick-blue-600",
    },
    disabled: {
      type: Boolean,
    },
  },

  methods: {
    changeValue() {
      this.$emit("switch", !this.active);
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  @apply relative h-[20px] w-[40px] cursor-pointer rounded-full;
  box-shadow: inset 0 0 5px var(--ontick-switch-opacity);
  transition: background 300ms linear;

  &::before {
    @apply absolute top-0 left-0 h-[20px] w-[20px] rounded-full bg-white;
    content: "";
    transform: scale(1.1);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    transition: left 300ms linear;
  }

  &.checked {
    @apply bg-ontick-blue-600;

    // background-image: url("");
    &::before {
      left: 20px;
    }
  }

  &.cursor-not-allowed {
    @apply cursor-not-allowed;
  }
}
</style>
